export enum TimeValidityType {
  unknown = 'unknown',
  amountUnit = 'amountunit',
  fromToDate = 'fromtodate',
  fromToDateTime = 'fromtodatetime',
}
